import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const RadioButtons = ({ label, name, value, options, setValue }) => (
    <FormControl component="fieldset">
        {label ? <FormLabel component="legend">{label}</FormLabel> : null}
        <RadioGroup
            aria-label={label}
            name={name}
            value={value}
            onChange={({ target: { value: newValue } }) => setValue(newValue)}
            row
        >
            {options.map(({ value: optionValue, label: optionLabel, disabled }) => (
                <FormControlLabel
                    key={`${name}-radio-button-${optionValue}`}
                    value={optionValue}
                    label={optionLabel}
                    control={<Radio />}
                    disabled={disabled}
                />
            ))}
        </RadioGroup>
    </FormControl>
);

RadioButtons.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    setValue: PropTypes.func.isRequired
};

export default RadioButtons;
